import { Subject } from 'rxjs';
import { Injectable } from '@angular/core';
import { MatDialog as MatDialog, MatDialogRef } from '@angular/material/dialog';

import { ModalParametrosComponent } from './../../pages/configuracoes/configuracoes-parametros/modal-parametros/modal-parametros.component';
import { ModalEmailComponent } from './../../pages/configuracoes/configuracoes-email/modal-email/modal-email.component';
import { IContractLot, ILot } from './../../models/generic';
import {
  IDialogCommissionData,
  IDialogConfirm,
  IDialogContractData
} from 'src/app/models/dialog';
import { CDialogComponent } from 'src/app/shared/components/c-dialog/c-dialog.component';
import { DialogContractsComponent } from '../../shared/components/dialog-contracts/dialog-contracts.component';
import { ComissaoDialogComponent } from 'src/app/pages/comissao-faturamento/comissao-dialog/comissao-dialog.component';
import { ModalContractVisualizeComponent } from 'src/app/shared/components/modal-contract-visualize/modal-contract-visualize.component';
import { IContractByNumberFormData } from 'src/app/models/contract';
import { IParameter } from 'src/app/models/parameter';
import { IEmailTemplateCard } from 'src/app/models/email';
import { ContractListManualDialogComponent } from 'src/app/pages/detalhes-lotes-manual/contract-list-manual-dialog/contract-list-manual-dialog.component';
import { ModalBatchEventLogComponent } from 'src/app/shared/components/modal-batch-event-log/modal-batch-event-log.component';
import { ModalTransferBatchMassCreateResultComponent } from 'src/app/shared/components/modal-transfer-batch-mass-create-result/modal-transfer-batch-mass-create-result.component';
import { IBatchEventLog } from 'src/app/models/batch-event-log';
import { ILogProcessSale } from 'src/app/models/log-process-sale';
import { ITransferBatchMassCreateResult } from 'src/app/models/generic';

@Injectable({
  providedIn: 'root'
})
export class ApiDialogService {
  searchFieldEvent: Subject<string> = new Subject<string>();

  constructor(private _dialog: MatDialog) { }

  openDialog(data: IDialogConfirm): Promise<string | boolean> {
    return new Promise((resolve, reject) => {
      const isBatchPreviewDialog = data?.appearance === 'modern' && data?.variant === 'batch-preview';
      const dialogRef = this._dialog.open(CDialogComponent, {
        disableClose: true,
        panelClass: isBatchPreviewDialog ? ['batch-preview-dialog'] : undefined,
        data
      });

      dialogRef.afterClosed().subscribe({
        next: (res) => resolve(res),
        error: (err) => reject(err)
      });
    });
  }

  openDialogContracts(
    data: IDialogContractData
  ): Promise<Array<IContractLot> | boolean> {
    return new Promise((resolve, reject) => {
      const dialogRef = this._dialog.open(DialogContractsComponent, {
        disableClose: true,
        panelClass: 'dialog-contracts',
        width: 'min(1150px, 96vw)',
        maxWidth: '96vw',
        data
      });

      dialogRef.afterClosed().subscribe({
        next: (res) => resolve(res),
        error: (err) => reject(err)
      });
    });
  }

  openDialogEmail(data: IEmailTemplateCard): Promise<any | boolean> {
    return new Promise((resolve, reject) => {
      const dialogRef = this._dialog.open(ModalEmailComponent, {
        disableClose: true,
        panelClass: 'email-dialog',
        data
      });

      dialogRef.afterClosed().subscribe({
        next: (res) => resolve(res),
        error: (err) => reject(err)
      });
    });
  }

  openDialogComission(data: IDialogCommissionData): Promise<any | boolean> {
    return new Promise((resolve, reject) => {
      const dialogRef = this._dialog.open(ComissaoDialogComponent, {
        disableClose: true,
        panelClass: 'comissao-dialog',
        maxWidth: '95vw',
        data
      });

      dialogRef.afterClosed().subscribe({
        next: (res) => resolve(res),
        error: (err) => reject(err)
      });
    });
  }

  openContractDetailsDialog(
    data: IContractByNumberFormData
  ): Promise<string | boolean | null> {
    return new Promise((resolve, reject) => {
      const dialogRef = this._dialog.open(ModalContractVisualizeComponent, {
        disableClose: true,
        panelClass: 'generic-dialog',
        ariaLabel: 'Visualizar contrato',
        data
      });
    });
  }

  openParameterDialog(
    data: IParameter
  ): Promise<IParameter | string | boolean | null> {
    return new Promise((resolve, reject) => {
      const dialogRef = this._dialog.open(ModalParametrosComponent, {
        disableClose: true,
        minWidth: '750px',
        minHeight: '300px',
        data
      });

      dialogRef.afterClosed().subscribe({
        next: (res) => resolve(res),
        error: (err) => reject(err)
      });
    });
  }

  openManualContractList(batch: ILot | {}): Promise<ILot | null> {
    return new Promise((resolve, reject) => {
      const dialogRef = this._dialog.open(ContractListManualDialogComponent, {
        disableClose: true,
        data: batch,
        panelClass: ['generic-dialog', 'reset-modal-style']
      });

      dialogRef.afterClosed().subscribe({
        next: (res) => resolve(res),
        error: (err) => reject(err)
      });
    });
  }

  openBatchEventLogDialog(logs: IBatchEventLog[], logsSap: ILogProcessSale[] ): Promise<string | boolean | null> {
    return new Promise((resolve, reject) => {
      const dialogRef = this._dialog.open(ModalBatchEventLogComponent, {
        disableClose: true,
        panelClass: 'generic-dialog',
        ariaLabel: 'Log de eventos do lote',
        data: {Logs: logs, LogSap: logsSap},
        maxWidth: 'min(1100px, 92vw)'
      });
    });

  }

  // Abre o dialog imediatamente (skeleton enquanto a execução ainda roda) e
  // devolve a referência pra quem chamou poder alimentar o resultado depois,
  // via dialogRef.componentInstance.setResult(...), quando a chamada
  // assíncrona de "Gerar lote automático" terminar.
  openTransferBatchMassCreateResultDialog(
    result: ITransferBatchMassCreateResult | null
  ): MatDialogRef<ModalTransferBatchMassCreateResultComponent> {
    return this._dialog.open(ModalTransferBatchMassCreateResultComponent, {
      disableClose: true,
      panelClass: 'transfer-batch-mass-create-result-dialog',
      ariaLabel: 'Relatório do loteamento automático',
      data: { Result: result },
      width: '1200px',
      maxWidth: '95vw'
    });
  }

}
